module.exports = __webpack_public_path__ + "img/sensor-normal.32fe214e.png";